import { render } from "./StockContainer.vue?vue&type=template&id=47135533"
import script from "./StockContainer.vue?vue&type=script&lang=js"
export * from "./StockContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\2\\s\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__